import { Group, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { Dot, type Tone } from "../../delivery/atoms"
import { stockLevel, type StockLevel } from "./utils"

export const STOCK_TONE: Record<StockLevel, Tone> = { ready: "green", low: "amber", out: "grey" }

/** Labelled stock dot: «27 ш бэлэн» / «Цөөн · 7 ш» / «Дууссан» (+ «нөөцийн захиалга» when backorderable). */
export function StockLabel({ stock, sellWithoutStock = false }: Readonly<{ stock: number; sellWithoutStock?: boolean }>) {
  const { t } = useTranslation("order")
  const level = stockLevel(stock)
  const text =
    level === "ready"
      ? t("catalog.stockReady", { count: stock })
      : level === "low"
        ? t("catalog.stockLow", { count: stock })
        : sellWithoutStock
          ? t("catalog.stockBackorder")
          : t("catalog.stockOut")
  return (
    <Group gap={6} wrap="nowrap" miw={0}>
      <Dot tone={STOCK_TONE[level]} />
      <Text span fz="var(--nw-fz-body)" c="var(--nw-text)" truncate>
        {text}
      </Text>
    </Group>
  )
}
